import styled from "styled-components";

import { PrimaryButton } from "components/Button";

export const CheckoutPageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const CheckoutContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  max-width: 375px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    max-width: 517px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: 684px;
  }
`;

export const BannerArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  padding: 76px 0px 64px;
  gap: 24px;
`;

export const StyledBannerInfo = styled.p`
  align-self: stretch;
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(24)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(32)};
  color: ${({ theme }) => theme.customTheme.palette.StyledBannerInfo.color};
  text-align: center;
  margin-bottom: 0;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(40)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(48)};
  }
`;

export const TotalToday = styled.span`
  background: ${({ theme }) => theme.customTheme.palette.TotalToday.bgColor};
  border-radius: 100px;
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(14)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(18)};
  padding: 4px 12px;
  text-align: center;
  color: ${({ theme }) => theme.customTheme.palette.TotalToday.color};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(24)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(32)};
  }
`;

export const Amount = styled.strong`
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(14)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(18)};
  color: ${({ theme }) => theme.customTheme.palette.Amount.color};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(24)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(32)};
  }
`;

export const CheckoutContent = styled.div`
  width: 100%;
  padding: 0 24px;
`;

export const ButtonContainer = styled.div`
  width: 100%;
`;

export const CheckoutBtn = styled(PrimaryButton)`
  margin: 0 auto;
  width: 100%;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    width: 336px;
    margin: 0;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: 327px;
    margin: 0;
  }
`;

export const OkBtn = styled(PrimaryButton)`
  width: 100%;
  background: ${({ theme }) => theme.customTheme.palette.OkBtn.bgColor};
`;

export const OkPrimaryBtn = styled(PrimaryButton)`
  width: 100%;
`;

export const OkWhiteBtn = styled(PrimaryButton)`
  width: 100%;
  background: ${({ theme }) => theme.customTheme.palette.OkWhiteBtn.bgColor};
  color: ${({ theme }) => theme.customTheme.palette.OkWhiteBtn.color};
  margin-top: ${({ theme }) => theme.customTheme.pxToRem(16)};
  border: 1px solid ${({ theme }) => theme.customTheme.palette.OkWhiteBtn.border};
`;
